
export default class ErrorHttp extends Error {
    constructor(message, status, body) {
        super(message);
        this.body = body;
        this.status = status;
    }
}
